module.exports = __webpack_public_path__ + "img/toggle.8f380cc8.svg";